import React from 'react'
import '../assets/sass/material-requisition.scss'

type Props = {
  itemNumber: number
}

export const StepNav1: React.FC<Props> = ({itemNumber}) => {
  return (
    <>
      <div
        className='stepper-1 stepper stepper-links d-flex flex-column w-100'
        id='kt_create_account_stepper'
      >
        <div className='stepper-nav m-0 pb-8 pt-5'>
          <div
            className={itemNumber >= 1 ? 'stepper-item current' : 'stepper-item'}
            data-kt-stepper-element='nav'
          >
            <div className='stepper-label'>
              {/* <img
                src={
                  itemNumber >= 1 ? '/media/wizard-icons/1-hover.png' : '/media/wizard-icons/1.png'
                }
                onMouseOver={(e) => (e.currentTarget.src = '/media/wizard-icons/1-hover.png')}
                onMouseOut={
                  itemNumber >= 1
                    ? (e) => (e.currentTarget.src = '/media/wizard-icons/1-hover.png')
                    : (e) => (e.currentTarget.src = '/media/wizard-icons/1.png')
                }
              /> */}
              <svg
                className='stepper-icon'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 278.74 383.3'
              >
                <defs></defs>
                <g id='Layer_2' data-name='Layer 2'>
                  <g id='Layer_1-2' data-name='Layer 1'>
                    <path
                      className='cls-1'
                      d='M259.91,0c2.87,1.15,6,1.94,8.56,3.53a20.52,20.52,0,0,1,10.19,17.66c0,.88,0,1.75,0,2.62q0,153.81.05,307.61c0,7.59-2.14,14-8,18.89a19.91,19.91,0,0,1-5.8,3.24c-2.85,1-5.17-.1-6.52-2.81s-.86-5.6,1.78-6.85c6.59-3.11,7.4-8.45,7.4-14.89q-.16-127.78-.08-255.59V68.34H11.19c0,3.82,0,7.75,0,11.68a37.15,37.15,0,0,1-.08,4.48,5.67,5.67,0,0,1-5.79,5.25,5.48,5.48,0,0,1-5.26-5.7C0,75.32,0,66.59,0,57.86c0-11.48,0-23,0-34.43C0,11.14,5.91,3.62,17.83.53a4.87,4.87,0,0,0,1-.53Zm7.6,56.76c0-11.52,0-22.72,0-33.92,0-7.4-4.2-11.53-11.69-11.53q-116.6,0-233.19,0c-7.17,0-11.36,4.23-11.4,11.43-.06,10.48,0,21,0,31.43a22.93,22.93,0,0,0,.28,2.59Z'
                    />
                    <path
                      className='cls-1'
                      d='M0,221.2q0-55.57,0-111.15c0-1.25-.06-2.5,0-3.74.27-3,2-4.87,5-5.16,3.19-.31,5.24,1.43,5.94,4.5a20.67,20.67,0,0,1,.21,4.46q0,110.4.1,220.79a18.83,18.83,0,0,0,2.13,8.82c2.17,3.88,6.37,4.31,10.52,4.3q37.82-.06,75.61,0h62.88a35.81,35.81,0,0,1,3.74.07c3.4.35,5.41,2.46,5.4,5.55s-2.06,5.13-5.47,5.46c-.87.08-1.75.06-2.62.06q-70,0-140,0c-12.18,0-20.75-6.42-23-17.23A32.41,32.41,0,0,1,0,331.22Q0,276.2,0,221.2Z'
                    />
                    <path
                      className='cls-1'
                      d='M139.16,240.43H64.65c-10.09,0-14.64-4.54-14.68-14.57,0-4.12-.1-8.24,0-12.35.25-7.3,4.93-12,12.22-12.55.87-.06,1.75,0,2.62,0q74.51,0,149,0c5.14,0,9.67,1,12.75,5.56s3.16,23.84.09,28.36c-2.74,4.06-6.67,5.65-11.54,5.64-22.71-.07-45.43,0-68.14,0Zm-.2-11.17h32.93c14,0,27.94-.08,41.91.06,2.95,0,4.06-.86,3.83-3.82-.2-2.73,0-5.48,0-8.23,0-5.17,0-5.18-5.07-5.18H66.22c-.75,0-1.5,0-2.25,0-2.09-.13-2.91.86-2.87,2.91.07,3.36.21,6.74,0,10.09s.86,4.26,4.19,4.24C89.82,229.19,114.39,229.26,139,229.26Z'
                    />
                    <path
                      className='cls-1'
                      d='M139.26,176.9H64.76c-10.29,0-14.77-4.52-14.79-14.84,0-4.12-.11-8.24.05-12.35.29-7.11,5-11.8,12.11-12.2,1-.06,2,0,3,0H213.75c1.24,0,2.5,0,3.74.11a11.89,11.89,0,0,1,11.09,11.18c.29,4.6.17,9.23.15,13.85,0,9.57-4.68,14.27-14.22,14.28Q176.89,176.94,139.26,176.9Zm.22-28.28c-24.57,0-49.14.09-73.7-.09-3.9,0-5.12,1.19-4.72,4.89a69.1,69.1,0,0,1,0,7.48c0,4.83,0,4.84,5,4.84H203.38c3.62,0,7.24-.13,10.85,0,2.68.13,3.51-1,3.39-3.51a69.3,69.3,0,0,1,0-9.34c.33-3.57-1.12-4.39-4.48-4.38C188.61,148.68,164,148.62,139.48,148.62Z'
                    />
                    <path
                      className='cls-1'
                      d='M241.69,342.19c3.49,6.07,6.8,11.76,10.05,17.49,3.81,6.74,2.49,11.79-4.14,15.75-3.64,2.17-7.29,4.31-11,6.32-5.58,3-10.84,1.6-14.13-3.85-3.59-6-7-12-10.72-18.41-4.33,2.48-8.49,4.89-12.67,7.26-8.48,4.81-15.71.76-15.74-8.91q-.07-32.18,0-64.33c0-9.45,7.31-13.64,15.51-8.94q27.87,16,55.66,32.13c8.29,4.81,8.18,13.24-.14,18.14C250.28,337.23,246.18,339.58,241.69,342.19Zm-47.07,14.19c4.39-2.51,8.12-4.73,11.92-6.81,5.66-3.1,11.13-1.68,14.52,3.73.93,1.47,1.77,3,2.65,4.51l8.06,13.87,10.06-5.86c0-.62,0-.77,0-.86-3.21-5.63-6.46-11.23-9.64-16.87-3.77-6.69-2.36-11.88,4.23-15.77,3.58-2.12,7.19-4.21,11.33-6.64L194.62,295Z'
                    />
                    <path
                      className='cls-1'
                      d='M139.31,268.64c4.61,0,9.22-.12,13.82,0,10.6.33,18.47,8.72,18.45,19.53s-8.05,19.29-18.55,19.47q-13.64.24-27.27,0c-10.5-.17-18.6-8.72-18.64-19.4s7.81-19.26,18.36-19.6C130.09,268.52,134.7,268.64,139.31,268.64Zm0,11.15h-12c-.25,0-.5,0-.75,0-5.06.23-8.2,3.36-8.24,8.23,0,5,3.2,8.42,8.39,8.48,8.36.08,16.72.06,25.07,0,5.29,0,8.58-3.27,8.63-8.25s-3.12-8.31-8.4-8.44C147.76,279.71,143.52,279.79,139.28,279.79Z'
                    />
                    <path
                      className='cls-1'
                      d='M139.35,89.84q25.28,0,50.53,0a29.79,29.79,0,0,1,3,0c3.19.34,5.08,2.19,5.19,5.34s-1.74,5.11-4.83,5.7a18.79,18.79,0,0,1-3.36.1H88.82a17.88,17.88,0,0,1-3.36-.11c-3.09-.59-4.95-2.51-4.83-5.7s2-5,5.21-5.33a29.75,29.75,0,0,1,3,0Q114.09,89.82,139.35,89.84Z'
                    />
                    <path
                      className='cls-1'
                      d='M85.94,17.07A17.06,17.06,0,1,1,69,34.28,17.14,17.14,0,0,1,85.94,17.07Zm6.12,17.58A6,6,0,1,0,85.58,40,6,6,0,0,0,92.06,34.65Z'
                    />
                    <path
                      className='cls-1'
                      d='M130.92,17.07a17.06,17.06,0,1,1-17,17.17A17.13,17.13,0,0,1,130.92,17.07Zm.1,11.19a5.82,5.82,0,0,0-5.9,5.88A5.89,5.89,0,0,0,131.07,40a6,6,0,0,0,6-5.9A5.93,5.93,0,0,0,131,28.26Z'
                    />
                    <path
                      className='cls-1'
                      d='M41.3,17.07A17.06,17.06,0,1,1,24.05,34,17.14,17.14,0,0,1,41.3,17.07Zm5.86,16.87A6,6,0,0,0,41,28.26a5.82,5.82,0,0,0-5.74,6A5.9,5.9,0,0,0,41.36,40,6,6,0,0,0,47.16,33.94Z'
                    />
                  </g>
                </g>
              </svg>

              <h3 className='stepper-title mt-5'>1. Material Requisition </h3>
            </div>
            <div className='stepper-arrow'>
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className='mh-50px'
              >
                <rect
                  opacity='0.5'
                  x='18'
                  y='13'
                  width='13'
                  height='2'
                  rx='1'
                  transform='rotate(-180 18 13)'
                  fill='black'
                ></rect>
                <path
                  d='M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z'
                  fill='black'
                ></path>
              </svg>
            </div>
          </div>

          <div
            className={itemNumber >= 2 ? 'stepper-item current' : 'stepper-item'}
            data-kt-stepper-element='nav'
          >
            <div className='stepper-label'>
              {/* <img
                src={
                  itemNumber >= 2 ? '/media/wizard-icons/6-hover.png' : '/media/wizard-icons/6.png'
                }
                onMouseOver={(e) => (e.currentTarget.src = '/media/wizard-icons/6-hover.png')}
                onMouseOut={
                  itemNumber >= 2
                    ? (e) => (e.currentTarget.src = '/media/wizard-icons/6-hover.png')
                    : (e) => (e.currentTarget.src = '/media/wizard-icons/6.png')
                }
              /> */}
              <svg
                className='stepper-icon'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 495.05 494.87'
              >
                <defs></defs>
                <g id='a' />
                <g id='b'>
                  <g id='c'>
                    <g>
                      <path
                        className='d'
                        d='M303.6,494.87H0V47.57H103.74V0H407.16V5.53c0,86.04,.02,172.09-.07,258.13,0,3.23,.84,5.23,3.66,6.97,6.17,3.78,11.9,8.29,18.19,11.84,3.8,2.15,8.27,4.25,12.49,4.36,17.86,.45,35.75,.15,53.62,.12v16.44c-15.79-.03-31.58-.27-47.36-.03-11.19,.17-21.12-2.78-30.37-9.13-16.71-11.47-33.71-22.51-50.52-33.84-5.11-3.44-10.61-5.35-16.76-5.12-1.21,.05-3.21,.74-3.45,1.55-2.21,7.45-4.11,14.99-6.09,22.48,15.99,4.5,23.67,16.19,20.15,29.92-2.88,11.25-12.47,17.98-25.93,18-26.91,.05-53.81,0-80.72,.03-2.57,0-5.16,.04-7.72,.31-11.51,1.23-20.77,12.08-19.77,23.45,1.55,0,3.13,0,4.72,0,19.01,0,38.03,.14,57.04-.04,17.55-.17,34.67,2.09,51.13,8.34,24.33,9.23,48.81,9.68,73.87,2.71,18.08-5.03,36.19-10.43,55.24-10.77,8.85-.16,17.7-.32,26.55-.49v16.44c-30.2-2.39-59.05,4.33-88,13.14v66.52h-103.44v48Zm-50.08-127.71c-7.67,0-15.04,0-22.42,0-14.45,0-18.47-3.1-21.53-15.41-6.31-1.16-12.51-1.11-17.63-3.45-15.85-7.23-18.8-26.88-6.38-40.06,3.89-4.12,8.37-7.68,12.59-11.5l-1.09-1.62h-29.13v-15.9c14.51,0,28.69,.03,42.86-.04,1.52,0,3.47-.06,4.48-.94,5.03-4.35,9.82-8.98,14.7-13.52l-.98-1.51h-61.08v-15.92c25.29,0,50.26,.03,75.23-.05,2,0,4.34-.2,5.93-1.23,7.57-4.92,15.82-6.89,24.74-6.64,4.44,.12,8.89,.02,13.29,.02V63.41H135.9v-15.47h167.76V179.12c1.15-1.23,1.55-2.55,1.91-3.89,6.48-24.05,12.92-48.11,19.46-72.15,4.97-18.3,21.68-27.48,39.7-22.16,12.82,3.79,24.78,18.14,18.97,38.79-10.8,38.36-20.94,76.9-31.33,115.37-.36,1.32-.48,2.7-.78,4.44,16.27-.87,26.83,10.61,39.49,17.52V15.98H119.86V63.64H16.42V478.65H286.98v-64.24c-2.59,.25-4.81,.47-6.96,.68-.96,3.42-1.83,6.47-2.76,9.78-5.26-1.32-10.18-2.56-15.27-3.84,.26-1.09,.37-1.88,.65-2.61,1.85-4.79,1.27-7.99-3.39-11.71-7.71-6.14-10.79-15.07-9.08-25.09,.81-4.72,2.15-9.35,3.35-14.47Zm62.83,1.89c-.57,1.74-.89,2.64-1.16,3.56-2.36,8.17-4.52,16.41-7.14,24.5-.96,2.97-4.1,5.52-4.3,8.41-.59,8.41-.21,16.89-.21,25.25h87.54v-48.67c-26.4,4.19-50.16-5.81-74.73-13.04Zm-1.09-58.01c10.39-38.41,20.77-76.81,31.23-115.48-9.25-3.08-18.15-6.05-27.39-9.13-11.25,41.66-22.42,83.01-33.66,124.61h29.82Zm-31.48-55.3c-14.64-2.34-25.99,1.59-35.97,12.43-15.58,16.91-32.35,32.72-48.61,49.01-1.25,1.25-2.54,2.49-3.56,3.91-2.43,3.4-2.07,8.12,.67,11.08,2.86,3.09,7.2,3.78,10.92,1.5,1.62-.99,3.06-2.34,4.42-3.69,12.09-12.04,24.2-24.05,36.17-36.2,7.43-7.55,15.82-13,26.67-14.07,1.24-.12,3.08-1.36,3.41-2.45,2.13-7.04,3.92-14.18,5.89-21.53Zm75.46-107.4c3.39-12.52,6.77-24.39,9.77-36.36,1.77-7.05-2.05-13.45-8.69-15.66-7.33-2.43-15.83,.18-18.06,6.74-4.01,11.78-7.05,23.88-10.57,36.11,9.45,3.15,18.24,6.07,27.56,9.17Zm-88.73,219.06c-.26,.4-.5,.63-.57,.91-1.22,4.48-2.51,8.94-3.62,13.45-1.88,7.65,1.58,14.26,8.54,16.55,7.95,2.61,16.16-.59,18.74-8,2.56-7.37,4.3-15.03,6.5-22.91h-29.59Zm52.78-196.41c9.39,3.11,18.27,6.05,27.41,9.07,1.53-5.78,2.9-10.97,4.31-16.31-9.41-3.09-18.27-6-27.37-8.99-1.53,5.69-2.85,10.63-4.35,16.23Zm8.59,140.04c5,.24,9.84,1,12.13-3.75,1.07-2.23,.94-5.66,.04-8.06-1.22-3.24-4.39-4.31-8.1-3.5-1.34,5.05-2.66,9.98-4.07,15.3Zm-62.96,0c1.3-4.94,2.52-9.59,3.73-14.23-.51-.41-1.02-.83-1.53-1.24-5.9,4.81-11.8,9.62-17.71,14.44l.7,1.04h14.79Z'
                      />
                      <path
                        className='d'
                        d='M239.39,79.93v79.11H32.2V79.93H239.39Zm-16.14,15.93H48.35v47.49H223.25v-47.49Z'
                      />
                      <path
                        className='d'
                        d='M95.55,223.27H48.31v63.59h63.5v-31.43h15.58v47.51H32.29v-95.27h63.26v15.61Z'
                      />
                      <path
                        className='d'
                        d='M32.16,343.21h63.33v15.85H48.25v63.77h63.31v-31.36h15.89v47.22H32.16v-95.48Z'
                      />
                      <path
                        className='d'
                        d='M79.2,388.8c25.7-25.68,50.3-50.26,74.82-74.77,3.66,3.57,7.32,7.13,10.78,10.5-28.46,28.43-56.79,56.74-84.86,84.79-6.74-6.76-13.76-13.79-20.68-20.74,3.17-3.09,6.83-6.66,10.81-10.54,2.56,3.02,5.56,6.56,9.12,10.76Z'
                      />
                      <path
                        className='d'
                        d='M79.93,273.42c-6.82-6.8-13.87-13.83-20.87-20.8,3.27-3.26,6.79-6.76,10.83-10.79,2.76,3.43,5.67,7.04,8.58,10.67,25.64-25.69,50.26-50.36,74.89-75.04,4.22,4.38,7.76,8.05,11.05,11.46-28.07,28.07-56.42,56.43-84.49,84.51Z'
                      />
                      <path className='d' d='M271.31,215.62v15.46h-103.34v-15.46h103.34Z' />
                      <path className='d' d='M239.45,439.14v15.62h-87.48v-15.62h87.48Z' />
                      <path className='d' d='M271.31,454.9h-15.55v-15.8h15.55v15.8Z' />
                      <path className='d' d='M79.42,127.24h-15.33v-15.4h15.33v15.4Z' />
                      <path className='d' d='M96.07,111.76h15.47v15.44h-15.47v-15.44Z' />
                      <path className='d' d='M143.47,127.35h-15.46v-15.45h15.46v15.45Z' />
                      <path className='d' d='M175.53,111.97v15.15h-15.71v-15.15h15.71Z' />
                      <path className='d' d='M207.46,127.26h-15.69v-15.27h15.69v15.27Z' />
                    </g>
                  </g>
                </g>
              </svg>

              <h3 className='stepper-title mt-5'>2. Material Issuance</h3>
            </div>
            <div className='stepper-arrow'>
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className='mh-50px'
              >
                <rect
                  opacity='0.5'
                  x='18'
                  y='13'
                  width='13'
                  height='2'
                  rx='1'
                  transform='rotate(-180 18 13)'
                  fill='black'
                ></rect>
                <path
                  d='M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z'
                  fill='black'
                ></path>
              </svg>
            </div>
          </div>
          <div
            className={itemNumber >= 3 ? 'stepper-item current' : 'stepper-item'}
            data-kt-stepper-element='nav'
          >
            <div className='stepper-label'>
              {/* <img
                src={
                  itemNumber >= 3 ? '/media/wizard-icons/7-hover.png' : '/media/wizard-icons/7.png'
                }
                onMouseOver={(e) => (e.currentTarget.src = '/media/wizard-icons/7-hover.png')}
                onMouseOut={
                  itemNumber >= 3
                    ? (e) => (e.currentTarget.src = '/media/wizard-icons/7-hover.png')
                    : (e) => (e.currentTarget.src = '/media/wizard-icons/7.png')
                }
              /> */}
              <svg
                className='stepper-icon'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 279.43 393.05'
              >
                <defs> </defs>
                <g id='a' />
                <g id='b'>
                  <g id='c'>
                    <g>
                      <path
                        className='d'
                        d='M260.53,0c1.23,.39,2.47,.77,3.7,1.16,8.86,2.78,14.96,10.8,15.1,20.18,.13,8.25,.04,16.49,.04,24.74,0,95.35-.03,190.69,.05,286.04,0,7.6-2.19,14.01-8.07,18.88-1.69,1.39-3.75,2.47-5.81,3.23-2.86,1.05-5.16-.12-6.53-2.8-1.39-2.73-.93-5.65,1.7-6.88,6.78-3.17,7.49-8.67,7.49-15.23-.11-85.47-.08-170.95-.08-256.42v-4.4H11.42c0,4.95,.07,10.02-.02,15.08-.07,3.95-2.51,6.49-5.85,6.36-2.95-.11-5.32-2.41-5.33-5.65-.04-21.49-.16-42.99,.11-64.48C.43,11.05,7.51,3.2,16.39,.79,17.03,.62,17.64,.27,18.26,0c.25,0,.5,0,.75,0,.78,.25,1.55,.72,2.33,.72,6.49,.02,12.98-.04,19.47-.07h45.74c25.47,.04,50.94,.07,76.41,.07,.77,0,1.54-.46,2.32-.71,10,0,20,0,30,0h15C227.03,0,243.78,0,260.53,0Zm7.59,56.86c0-10.97,0-21.59,0-32.2,0-9.69-3.62-13.31-13.3-13.32-70.97-.01-141.93-.03-212.9-.03-6.25,0-12.49,.01-18.74,.04-7.63,.03-11.73,4.13-11.76,11.84-.03,10.24-.01,20.49,0,30.73,0,.95,.09,1.9,.15,2.94H268.13Z'
                      />
                      <path
                        className='d'
                        d='M165.27,0c-.77,.25-1.54,.71-2.32,.71-25.47,0-50.94-.03-76.41-.05-.03-.22-.04-.44-.03-.66C112.77,0,139.02,0,165.27,0Z'
                      />
                      <path
                        className='d'
                        d='M86.52,0c0,.22,0,.44,.03,.66-15.25,0-30.49,0-45.74-.01-.03-.21-.04-.43-.04-.65h45.75Z'
                      />
                      <path
                        className='d'
                        d='M40.76,0c0,.22,.02,.43,.04,.65-6.49,.03-12.98,.1-19.47,.07-.78,0-1.55-.47-2.33-.72h21.75Z'
                      />
                      <path
                        className='d'
                        d='M.17,221.5c0-37.12,0-74.23,0-111.35,0-1.25-.06-2.51,.05-3.75,.28-3.03,2.05-4.82,5.02-5.12,3.01-.3,5.08,1.25,5.87,4.12,.39,1.41,.31,2.97,.31,4.46,.01,73.73,.01,147.46,.01,221.19,0,10.06,3.42,13.5,13.45,13.5,46.12,0,92.23,0,138.35,.01,1.49,0,3.03-.04,4.47,.27,2.98,.63,4.47,2.66,4.34,5.67-.13,2.83-1.72,4.63-4.55,5.13-1.22,.21-2.49,.2-3.73,.2-46.49,0-92.99-.21-139.48,.13-15.35,.11-24.45-11.16-24.28-24.24,.47-36.73,.16-73.48,.16-110.22Z'
                      />
                      <path
                        className='d'
                        d='M139.77,177.27c-24.87,0-49.75,0-74.62,0-10.46,0-14.95-4.55-14.97-15.11,0-3.12,0-6.25,0-9.37,.02-10.55,4.53-15.11,14.97-15.12,18.5-.01,37,0,55.5,0,31.12,0,62.25,0,93.37,0,10.94,0,15.34,4.45,15.35,15.5,0,3.12,0,6.25,0,9.37-.03,10.05-4.64,14.72-14.6,14.73-25,.02-50,0-75,0Zm-.17-11.28c24.87,0,49.74-.06,74.61,.07,3.17,.02,4.19-.93,3.93-4.01-.24-2.85-.28-5.77,0-8.61,.37-3.61-.93-4.57-4.53-4.57-49.24,.12-98.48,.08-147.71,.08-.62,0-1.25,.05-1.87,0-1.98-.19-2.64,.75-2.59,2.65,.09,3.5,.22,7.01-.04,10.49-.23,3.14,.85,3.99,3.97,3.97,24.74-.12,49.49-.07,74.23-.07Z'
                      />
                      <path
                        className='d'
                        d='M139.53,240.9c-24.87,0-49.75,0-74.62,0-10.08,0-14.69-4.58-14.73-14.58-.01-4.12-.11-8.25,.04-12.37,.26-7.45,5.09-12.3,12.54-12.67,2.49-.12,5-.03,7.5-.03,47.87,0,95.75,0,143.62,0,11,0,15.48,4.47,15.49,15.42,0,3.37,.02,6.75,0,10.12-.08,9.3-4.82,14.09-14.08,14.1-25.25,.03-50.5,0-75.75,0Zm.24-11.26c2.75,0,5.5,0,8.25,0,22.13,0,44.25-.06,66.38,.07,3.02,.02,3.99-.86,3.75-3.81-.23-2.86-.29-5.77,0-8.61,.39-3.73-.79-4.88-4.7-4.87-49.13,.14-98.26,.09-147.39,.09-.63,0-1.25,.05-1.87,0-2.16-.19-2.84,.87-2.78,2.91,.09,3.37,.24,6.77-.04,10.12-.27,3.29,.78,4.21,4.14,4.19,24.75-.15,49.5-.08,74.26-.08Z'
                      />
                      <path
                        className='d'
                        d='M139.97,269.07c4.5,0,9-.11,13.5,.02,10.81,.33,18.7,8.8,18.62,19.85-.08,10.69-8.26,19.16-18.83,19.3-9,.12-18,.12-27,0-10.55-.14-18.73-8.65-18.81-19.33-.07-10.88,7.72-19.41,18.27-19.8,4.74-.17,9.5-.03,14.25-.03h0Zm-.39,11.23c-4.25,0-8.49-.09-12.74,.02-5.03,.13-8.14,3.39-8.14,8.3,0,4.87,3.21,8.29,8.13,8.35,8.61,.1,17.23,.1,25.85,0,4.93-.05,8.14-3.48,8.14-8.34,0-4.9-3.12-8.18-8.13-8.31-4.37-.11-8.74-.02-13.11-.02Z'
                      />
                      <path
                        className='d'
                        d='M140.17,89.97c16.74,0,33.48,0,50.22,0,1.12,0,2.27-.1,3.37,.07,2.99,.45,4.73,2.33,4.88,5.28,.15,2.98-1.53,4.95-4.39,5.73-1.06,.29-2.23,.17-3.36,.17-34.11,0-68.21,0-102.32,0-.87,0-1.76,.06-2.62-.05-3.12-.42-5.39-2.97-5.08-5.9,.33-3.12,2.11-5,5.32-5.25,1.37-.11,2.75-.04,4.12-.04,16.62,0,33.23,0,49.85,0Z'
                      />
                      <path
                        className='d'
                        d='M41.32,17.06c9.49-.04,17.22,7.48,17.36,16.9,.14,9.48-7.77,17.42-17.31,17.38-9.46-.04-17.1-7.7-17.12-17.14-.01-9.48,7.57-17.09,17.06-17.14Zm6.1,17.2c.06-3.21-2.61-5.89-5.89-5.94-3.34-.04-5.97,2.47-6.01,5.76-.05,3.25,2.58,5.94,5.83,5.98,3.24,.04,6.01-2.62,6.07-5.81Z'
                      />
                      <path
                        className='d'
                        d='M131.56,17.06c9.46,.05,17.14,7.73,17.13,17.13,0,9.36-7.75,17.1-17.16,17.15-9.6,.05-17.34-7.74-17.26-17.37,.08-9.43,7.78-16.96,17.29-16.91Zm5.87,17c-.07-3.22-2.8-5.79-6.09-5.74-3.32,.05-5.88,2.67-5.81,5.96,.06,3.25,2.76,5.84,6.03,5.77,3.24-.06,5.94-2.82,5.87-5.99Z'
                      />
                      <path
                        className='d'
                        d='M86.57,17.06c9.45,.06,17.14,7.76,17.11,17.15-.02,9.36-7.78,17.09-17.19,17.13-9.59,.04-17.33-7.76-17.24-17.39,.09-9.43,7.8-16.95,17.31-16.89Zm-.13,23c3.23,0,5.99-2.71,5.99-5.89,0-3.21-2.7-5.85-5.98-5.85-3.33,0-5.93,2.56-5.93,5.85,0,3.26,2.65,5.89,5.92,5.89Z'
                      />
                      <path
                        className='d'
                        d='M210.31,365.43c0-2.76,0-4.57,0-6.38,0-53.62,0-22.25,.02-75.87,0-2.17,.04-4.43,.47-6.51,.8-3.78,2.98-5.73,6.13-5.64,3.18,.09,5.16,2.36,5.92,6.06,.37,1.78,.26,3.73,.26,5.61,.01,53.94,0,22.87,0,76.81v4.98l.84,.59c4.28-5.39,8.53-10.81,12.84-16.17,1.24-1.54,2.49-3.16,3.96-4.32,2.7-2.12,5.4-1.5,7.57,1.23,2.17,2.73,2.59,6.06,.92,9.46-.65,1.32-1.53,2.48-2.41,3.59-7.99,10-15.98,20-24.01,29.95-4.56,5.65-7.6,5.62-12.18-.06-8.11-10.07-16.26-20.09-24.22-30.35-1.46-1.88-2.98-4.89-2.82-7.2,.17-2.45,1.94-5.35,3.68-6.86,2.44-2.13,5.15-.64,7.18,1.8,4.25,5.12,8.39,10.39,12.59,15.58,.85,1.05,1.76,2.01,3.25,3.7Z'
                      />
                    </g>
                  </g>
                </g>
              </svg>

              <h3 className='stepper-title mt-5'>3. Outward Form</h3>
            </div>
            <div className='stepper-arrow'>
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className='mh-50px'
              >
                <rect
                  opacity='0.5'
                  x='18'
                  y='13'
                  width='13'
                  height='2'
                  rx='1'
                  transform='rotate(-180 18 13)'
                  fill='black'
                ></rect>
                <path
                  d='M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z'
                  fill='black'
                ></path>
              </svg>
            </div>
          </div>
          <div
            className={itemNumber >= 4 ? 'stepper-item current' : 'stepper-item'}
            data-kt-stepper-element='nav'
          >
            <div className='stepper-label'>
              {/* <img
                src={
                  itemNumber >= 4 ? '/media/wizard-icons/8-hover.png' : '/media/wizard-icons/8.png'
                }
                onMouseOver={(e) => (e.currentTarget.src = '/media/wizard-icons/8-hover.png')}
                onMouseOut={
                  itemNumber >= 4
                    ? (e) => (e.currentTarget.src = '/media/wizard-icons/8-hover.png')
                    : (e) => (e.currentTarget.src = '/media/wizard-icons/8.png')
                }
              /> */}
              <svg
                className='stepper-icon'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 279.43 393.05'
              >
                <defs></defs>
                <g id='a' />
                <g id='b'>
                  <g id='c'>
                    <g>
                      <path
                        className='d'
                        d='M260.53,0c1.23,.39,2.47,.77,3.7,1.16,8.86,2.78,14.96,10.8,15.1,20.18,.13,8.25,.04,16.49,.04,24.74,0,95.35-.03,190.69,.05,286.04,0,7.6-2.19,14.01-8.07,18.88-1.69,1.39-3.75,2.47-5.81,3.23-2.86,1.05-5.16-.12-6.53-2.8-1.39-2.73-.93-5.65,1.7-6.88,6.78-3.17,7.49-8.67,7.49-15.23-.11-85.47-.08-170.95-.08-256.42v-4.4H11.42c0,4.95,.07,10.02-.02,15.08-.07,3.95-2.51,6.49-5.85,6.36-2.95-.11-5.32-2.41-5.33-5.65-.04-21.49-.16-42.99,.11-64.48C.43,11.05,7.51,3.2,16.39,.79,17.03,.62,17.64,.27,18.26,0c.25,0,.5,0,.75,0,.78,.25,1.55,.72,2.33,.72,6.49,.02,12.98-.04,19.47-.07h45.74c25.47,.04,50.94,.07,76.41,.07,.77,0,1.54-.46,2.32-.71,10,0,20,0,30,0h15C227.03,0,243.78,0,260.53,0Zm7.59,56.86c0-10.97,0-21.59,0-32.2,0-9.69-3.62-13.31-13.3-13.32-70.97-.01-141.93-.03-212.9-.03-6.25,0-12.49,.01-18.74,.04-7.63,.03-11.73,4.13-11.76,11.84-.03,10.24-.01,20.49,0,30.73,0,.95,.09,1.9,.15,2.94H268.13Z'
                      />
                      <path
                        className='d'
                        d='M165.27,0c-.77,.25-1.54,.71-2.32,.71-25.47,0-50.94-.03-76.41-.05-.03-.22-.04-.44-.03-.66C112.77,0,139.02,0,165.27,0Z'
                      />
                      <path
                        className='d'
                        d='M86.52,0c0,.22,0,.44,.03,.66-15.25,0-30.49,0-45.74-.01-.03-.21-.04-.43-.04-.65h45.75Z'
                      />
                      <path
                        className='d'
                        d='M40.76,0c0,.22,.02,.43,.04,.65-6.49,.03-12.98,.1-19.47,.07-.78,0-1.55-.47-2.33-.72h21.75Z'
                      />
                      <path
                        className='d'
                        d='M.17,221.5c0-37.12,0-74.23,0-111.35,0-1.25-.06-2.51,.05-3.75,.28-3.03,2.05-4.82,5.02-5.12,3.01-.3,5.08,1.25,5.87,4.12,.39,1.41,.31,2.97,.31,4.46,.01,73.73,.01,147.46,.01,221.19,0,10.06,3.42,13.5,13.45,13.5,46.12,0,92.23,0,138.35,.01,1.49,0,3.03-.04,4.47,.27,2.98,.63,4.47,2.66,4.34,5.67-.13,2.83-1.72,4.63-4.55,5.13-1.22,.21-2.49,.2-3.73,.2-46.49,0-92.99-.21-139.48,.13-15.35,.11-24.45-11.16-24.28-24.24,.47-36.73,.16-73.48,.16-110.22Z'
                      />
                      <path
                        className='d'
                        d='M139.77,177.27c-24.87,0-49.75,0-74.62,0-10.46,0-14.95-4.55-14.97-15.11,0-3.12,0-6.25,0-9.37,.02-10.55,4.53-15.11,14.97-15.12,18.5-.01,37,0,55.5,0,31.12,0,62.25,0,93.37,0,10.94,0,15.34,4.45,15.35,15.5,0,3.12,0,6.25,0,9.37-.03,10.05-4.64,14.72-14.6,14.73-25,.02-50,0-75,0Zm-.17-11.28c24.87,0,49.74-.06,74.61,.07,3.17,.02,4.19-.93,3.93-4.01-.24-2.85-.28-5.77,0-8.61,.37-3.61-.93-4.57-4.53-4.57-49.24,.12-98.48,.08-147.71,.08-.62,0-1.25,.05-1.87,0-1.98-.19-2.64,.75-2.59,2.65,.09,3.5,.22,7.01-.04,10.49-.23,3.14,.85,3.99,3.97,3.97,24.74-.12,49.49-.07,74.23-.07Z'
                      />
                      <path
                        className='d'
                        d='M139.53,240.9c-24.87,0-49.75,0-74.62,0-10.08,0-14.69-4.58-14.73-14.58-.01-4.12-.11-8.25,.04-12.37,.26-7.45,5.09-12.3,12.54-12.67,2.49-.12,5-.03,7.5-.03,47.87,0,95.75,0,143.62,0,11,0,15.48,4.47,15.49,15.42,0,3.37,.02,6.75,0,10.12-.08,9.3-4.82,14.09-14.08,14.1-25.25,.03-50.5,0-75.75,0Zm.24-11.26c2.75,0,5.5,0,8.25,0,22.13,0,44.25-.06,66.38,.07,3.02,.02,3.99-.86,3.75-3.81-.23-2.86-.29-5.77,0-8.61,.39-3.73-.79-4.88-4.7-4.87-49.13,.14-98.26,.09-147.39,.09-.63,0-1.25,.05-1.87,0-2.16-.19-2.84,.87-2.78,2.91,.09,3.37,.24,6.77-.04,10.12-.27,3.29,.78,4.21,4.14,4.19,24.75-.15,49.5-.08,74.26-.08Z'
                      />
                      <path
                        className='d'
                        d='M139.97,269.07c4.5,0,9-.11,13.5,.02,10.81,.33,18.7,8.8,18.62,19.85-.08,10.69-8.26,19.16-18.83,19.3-9,.12-18,.12-27,0-10.55-.14-18.73-8.65-18.81-19.33-.07-10.88,7.72-19.41,18.27-19.8,4.74-.17,9.5-.03,14.25-.03h0Zm-.39,11.23c-4.25,0-8.49-.09-12.74,.02-5.03,.13-8.14,3.39-8.14,8.3,0,4.87,3.21,8.29,8.13,8.35,8.61,.1,17.23,.1,25.85,0,4.93-.05,8.14-3.48,8.14-8.34,0-4.9-3.12-8.18-8.13-8.31-4.37-.11-8.74-.02-13.11-.02Z'
                      />
                      <path
                        className='d'
                        d='M140.17,89.97c16.74,0,33.48,0,50.22,0,1.12,0,2.27-.1,3.37,.07,2.99,.45,4.73,2.33,4.88,5.28,.15,2.98-1.53,4.95-4.39,5.73-1.06,.29-2.23,.17-3.36,.17-34.11,0-68.21,0-102.32,0-.87,0-1.76,.06-2.62-.05-3.12-.42-5.39-2.97-5.08-5.9,.33-3.12,2.11-5,5.32-5.25,1.37-.11,2.75-.04,4.12-.04,16.62,0,33.23,0,49.85,0Z'
                      />
                      <path
                        className='d'
                        d='M41.32,17.06c9.49-.04,17.22,7.48,17.36,16.9,.14,9.48-7.77,17.42-17.31,17.38-9.46-.04-17.1-7.7-17.12-17.14-.01-9.48,7.57-17.09,17.06-17.14Zm6.1,17.2c.06-3.21-2.61-5.89-5.89-5.94-3.34-.04-5.97,2.47-6.01,5.76-.05,3.25,2.58,5.94,5.83,5.98,3.24,.04,6.01-2.62,6.07-5.81Z'
                      />
                      <path
                        className='d'
                        d='M131.56,17.06c9.46,.05,17.14,7.73,17.13,17.13,0,9.36-7.75,17.1-17.16,17.15-9.6,.05-17.34-7.74-17.26-17.37,.08-9.43,7.78-16.96,17.29-16.91Zm5.87,17c-.07-3.22-2.8-5.79-6.09-5.74-3.32,.05-5.88,2.67-5.81,5.96,.06,3.25,2.76,5.84,6.03,5.77,3.24-.06,5.94-2.82,5.87-5.99Z'
                      />
                      <path
                        className='d'
                        d='M86.57,17.06c9.45,.06,17.14,7.76,17.11,17.15-.02,9.36-7.78,17.09-17.19,17.13-9.59,.04-17.33-7.76-17.24-17.39,.09-9.43,7.8-16.95,17.31-16.89Zm-.13,23c3.23,0,5.99-2.71,5.99-5.89,0-3.21-2.7-5.85-5.98-5.85-3.33,0-5.93,2.56-5.93,5.85,0,3.26,2.65,5.89,5.92,5.89Z'
                      />
                      <path
                        className='d'
                        d='M210.31,298.65c0,2.76,0,4.57,0,6.38,0,53.62,0,22.25,.02,75.87,0,2.17,.04,4.43,.47,6.51,.8,3.78,2.98,5.73,6.13,5.64,3.18-.09,5.16-2.36,5.92-6.06,.37-1.78,.26-3.73,.26-5.61,.01-53.94,0-22.87,0-76.81v-4.98l.84-.59c4.28,5.39,8.53,10.81,12.84,16.17,1.24,1.54,2.49,3.16,3.96,4.32,2.7,2.12,5.4,1.5,7.57-1.23,2.17-2.73,2.59-6.06,.92-9.46-.65-1.32-1.53-2.48-2.41-3.59-7.99-10-15.98-20-24.01-29.95-4.56-5.65-7.6-5.62-12.18,.06-8.11,10.07-16.26,20.09-24.22,30.35-1.46,1.88-2.98,4.89-2.82,7.2,.17,2.45,1.94,5.35,3.68,6.86,2.44,2.13,5.15,.64,7.18-1.8,4.25-5.12,8.39-10.39,12.59-15.58,.85-1.05,1.76-2.01,3.25-3.7Z'
                      />
                    </g>
                  </g>
                </g>
              </svg>

              <h3 className='stepper-title mt-5'>4. Inward Form</h3>
            </div>
            <div className='stepper-arrow'>
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className='mh-50px'
              >
                <rect
                  opacity='0.5'
                  x='18'
                  y='13'
                  width='13'
                  height='2'
                  rx='1'
                  transform='rotate(-180 18 13)'
                  fill='black'
                ></rect>
                <path
                  d='M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z'
                  fill='black'
                ></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
